export enum NativePlatform {
	Windows = 'windows',
	Mac = 'mac',
	Linux = 'linux',
	iOS = 'ios',
}
